import { render, staticRenderFns } from "./CompanyUpsertProvider.vue?vue&type=template&id=50011071&scoped=true&"
import script from "./CompanyUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./CompanyUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50011071",
  null
  
)

export default component.exports